<div class="accaboost-ladder-items">
    @for (item of ladderItems(); track index; let index = $index; let isfirst = $first) {
        <bs-acca-boost-carousel-item
            [model]="item"
            [picksCount]="pickCount"
            [ngClass]="isfirst ? 'first-item' : 'second-item'"
            [itemCount]="ladderItems().length"></bs-acca-boost-carousel-item>
    }
    <bs-acca-boost-carousel-max-boost-item
        class="max-boost-carousel-item__wrapper"
        [ngClass]="{
            'acca-boost-expand-max-item': ladderItems().length === 1 || maxItem.selected,
            'max-legs-reached': !ladderItems().length,
            'max-legs-exceeded': pickCount > maxItem.numberOfLegs,
        }"
        [picksCount]="pickCount"
        [model]="maxItem"></bs-acca-boost-carousel-max-boost-item>
</div>
